// tslint:disable:no-any

import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Loader from '../components/Loader';
import { getExpirateMessage } from '../components/Message';
import { DiveService } from '../services/DiveService';

export interface INewShareDive {
    match: any;
}

interface INewShareState {
    redirectSuccess: boolean;
    redirectError: boolean;
}

class NewShareDive extends Component<INewShareDive, INewShareState> {
    constructor(props: INewShareDive) {
        super(props);
        this.state = {
            redirectSuccess: false,
            redirectError: false
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        // pokus o potvrzeni ponoru
        DiveService.getInstance().createSharedDive(this.props.match.params.tokenId)
            .then(response => {
                if (response == undefined) {
                    return;
                }
                // bad request
                if (response.status === 400) {
                    this.redirectToError();
                }

                // done
                if (response.status === 200) {
                    this.redirectToSuccess();
                }
                return response;
            })
            .catch(error => {
                this.redirectToError();
            });
    }

    redirectToSuccess() {
        this.setState({
            redirectSuccess: true
        });
    }

    redirectToError() {
        this.setState({
            redirectError: true
        });
    }

    render() {
        return (
            <div>
                {this.state.redirectSuccess && (
                    <Redirect
                        to={{
                            pathname: '/app/shared-dives',
                            state: {
                                message: 'Congratulations! Dive was added',
                                messageType: 'success',
                                messageExpirate: getExpirateMessage()
                            }
                        }}
                    />
                )}

                {this.state.redirectError && (
                    <Redirect to="/app/?error=add-shared-dive" />
                )}

                <Loader />
            </div>
        );
    }
}

export default NewShareDive;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NewShareDive.tsx